module.exports = __webpack_public_path__ + "media/images/landing/home/categories/expos-bb513bef73eeca127837a2fdfe3719fc.png";